var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSubmitArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 22 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  strokeWidth: 1.5,
  d: "M0 10h20m0 0-8.418-9M20 10l-8.418 9"
})));
export default SvgIconSubmitArrow;